module.exports = __webpack_public_path__ + "img/app-store.189e324b.svg";